import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex h-full w-full items-center justify-center" }
const _hoisted_2 = {
  style: { gridTemplateColumns: '5fr min-content' },
  class: "grid grid-cols-2 gap-x-4"
}
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-4" }
const _hoisted_4 = { class: "relative col-span-2 items-center py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_dx_date_box = _resolveComponent("dx-date-box")!
  const _component_add_delete_buttons = _resolveComponent("add-delete-buttons")!
  const _component_form_group = _resolveComponent("form-group")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_form_wrapper, {
      "is-form-in-modal": _ctx.isFormInModal,
      "is-loading": _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createVNode(_component_form_divider, null, {
            default: _withCtx(() => [
              _createVNode(_component_input_field, {
                modelValue: _ctx.authResource.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authResource.email) = $event)),
                disabled: true,
                label: "Email"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_checkbox_input, {
                modelValue: _ctx.isAllPermissionCheckBoxChecked,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAllPermissionCheckBoxChecked) = $event)),
                "is-checked": _ctx.isAllPermissionCheckBoxChecked,
                label: "Give permission for all resources"
              }, null, 8, ["modelValue", "is-checked"]),
              (!_ctx.isAllPermissionCheckBoxChecked)
                ? (_openBlock(), _createBlock(_component_form_group, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authResource.authResources, (resource, index) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Resource", -1)),
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_small_loader, {
                                    key: 0,
                                    height: "h-8",
                                    width: "w-8"
                                  }))
                                : (_openBlock(), _createBlock(_component_v_select, {
                                    key: 1,
                                    modelValue: resource.onResourceId,
                                    "onUpdate:modelValue": ($event: any) => ((resource.onResourceId) = $event),
                                    clearable: false,
                                    options: _ctx.resourcesForSelect,
                                    reduce: (type) => type.id,
                                    class: "mt-1 w-full",
                                    label: "name"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "reduce"]))
                            ]),
                            _createElementVNode("div", null, [
                              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "From", -1)),
                              _createVNode(_component_dx_date_box, {
                                modelValue: resource.policyValidFrom,
                                "onUpdate:modelValue": ($event: any) => ((resource.policyValidFrom) = $event),
                                height: 42,
                                "show-clear-button": false,
                                "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                                type: "datetime",
                                "accept-custom-value": false
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "display-format"])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "To", -1)),
                              _createVNode(_component_dx_date_box, {
                                modelValue: resource.policyValidTo,
                                "onUpdate:modelValue": ($event: any) => ((resource.policyValidTo) = $event),
                                height: 42,
                                "show-clear-button": true,
                                "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                                type: "datetime",
                                "accept-custom-value": false
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "display-format"])
                            ])
                          ]),
                          _createVNode(_component_add_delete_buttons, {
                            "auth-resources": _ctx.authResource.authResources,
                            index: index,
                            onRemoveClick: () => _ctx.removeAuthResource(resource, index),
                            onAddClick: _ctx.addAuthResource
                          }, null, 8, ["auth-resources", "index", "onRemoveClick", "onAddClick"])
                        ]))
                      }), 256))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
        ], 32)
      ]),
      _: 1
    }, 8, ["is-form-in-modal", "is-loading"])
  ]))
}